import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import BankResponseImport from "./BankResponseImport";

/**
 * Route wrapper for the response importer.
 *
 * The importer needs a specific ``batch_id``. If none is present in the query string
 * (``?batch_id=…``), we render a simple picker so ops can paste one from the batch list.
 */
export default function BankResponseImportPage() {
  const [params, setParams] = useSearchParams();
  const batchId = params.get("batch_id") || "";
  const [draft, setDraft] = useState(batchId);

  if (!batchId) {
    return (
      <div style={{ padding: 20 }}>
        <h2 style={{ margin: 0 }}>Import Bank Response</h2>
        <div style={{ marginTop: 8, color: "#64748b", fontSize: 13 }}>
          Choose the salary batch this response file belongs to.
        </div>
        <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value.trim())}
            placeholder="Batch id (UUID)"
            style={{
              padding: "8px 12px",
              width: 360,
              border: "1px solid #cbd5e1",
              borderRadius: 6,
              fontFamily: "monospace",
            }}
          />
          <button
            disabled={!draft}
            onClick={() => setParams({ batch_id: draft })}
            style={{
              padding: "8px 12px",
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 6,
            }}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  return <BankResponseImport batchId={batchId} />;
}
